import { AmChartsService } from '@amcharts/amcharts3-angular';
import { SurvivalHorizonService } from './../../survival-horizon/survival-horizon.service';
import { DashboardEventService } from './../../dashboard/dashboard-event.service';
import { MetricSelection, MetricSelectionType } from './../metric-selection';
import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, Output } from '@angular/core';
import { BreachMetric } from './breach-metric';

@Component({
    selector: 'app-breach-metric',
    templateUrl: './breach-metric.component.html',
    styleUrls: ['./breach-metric.component.scss', './../trend-metric/trend-metric.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreachMetricComponent implements OnInit, OnDestroy {
    @Input()
    breach: BreachMetric;
    @Output()
    breachColor: string;


    constructor(private amCharts: AmChartsService,
        private survivalHorizonService: SurvivalHorizonService,
        private dashboardEventService: DashboardEventService,
        private changeDetectorRef: ChangeDetectorRef) {

    }
    ngOnInit() {
    }

    ngOnDestroy() {
        this.changeDetectorRef.detach();
    }

    refreshMetric() {
        this.breachColor = this.lightMetricColor(this.breach);
        this.changeDetectorRef.markForCheck();
    }

    onHistory() {
        this.dashboardEventService.metricSelectionSubject.next(
            new MetricSelection('HISTORY', this.breach.currency, this.breach.metricType, this.breach.name, this.breach)
        );
    }

    metricColor(breach: BreachMetric) {
        return breach.colors[0];
    }

    darkMetricColor(breach: BreachMetric) {
        return breach.colors[1];
    }

    lightMetricColor(breach: BreachMetric) {
        return breach.colors[2];
    }
}
